import LPV2MainProductStateManager from './state-manager';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

 

export function initSkioPickerBlock() {
	// Track the previous variant to detect variant changes
	let previousVariantId = null;
	
	function runPickerInit() {
		console.log('[LPv2 Skio Picker] Running picker initialization...');
		const svgAdd = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
  <path d="M7.52344 0.400391C11.4585 0.400547 14.6465 3.58004 14.6465 7.5C14.6465 11.42 11.4585 14.5995 7.52344 14.5996C3.58827 14.5996 0.400391 11.4201 0.400391 7.5C0.400391 3.57994 3.58827 0.400391 7.52344 0.400391Z" stroke="black" stroke-width="0.8"/>
</svg>`;
		const svgSelected = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
  <path d="M7.52344 0.400391C11.4585 0.400547 14.6465 3.58004 14.6465 7.5C14.6465 11.42 11.4585 14.5995 7.52344 14.5996C3.58827 14.5996 0.400391 11.4201 0.400391 7.5C0.400391 3.57994 3.58827 0.400391 7.52344 0.400391Z" stroke="black" stroke-width="0.8"/>
  <path d="M7.52319 2.04688C10.5456 2.0469 12.9939 4.48915 12.9939 7.5C12.9938 10.5107 10.5456 12.9531 7.52319 12.9531C4.5008 12.9531 2.05262 10.5108 2.05249 7.5C2.05249 4.48913 4.50072 2.04688 7.52319 2.04688Z" fill="black" stroke="black" stroke-width="0.614453"/>
</svg>`;


		const stateManager = window.lpv2MainProductStateManager || new LPV2MainProductStateManager();
		const container = document.querySelector('.lpv2-main-product-skio-picker-v2');
		if (!container) {
			console.warn('[LPv2 Skio Picker] .lpv2-main-product-skio-picker-v2 not found in DOM');
			return;
		}

		function formatMoney(amount, currency, locale) {
			// amount in cents
			
			// Use Shopify's built-in money formatting if available
			if (window.Shopify && window.Shopify.formatMoney && window.moneyFormat) {
				return Shopify.formatMoney(amount, window.moneyFormat);
			}
			
			// Fallback to Intl.NumberFormat with provided currency and locale
			return new Intl.NumberFormat(locale || 'en-GB', {
				style: 'currency',
				currency: currency || 'GBP',
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}).format(amount / 100);
		}

		function updatePlanCardButtons(state, isAvailable, hasVariant) {
			const sharedAddToCartBtn = container.querySelector('.lpv2-plan-action-btn');
			const sharedNotifyBtn = container.querySelector('.lpv2-plan-action-notify-btn');

			if (sharedAddToCartBtn || sharedNotifyBtn) {
				const selectedRadio = container.querySelector('.lpv2-plan-radio:checked');
				const activePlanType = selectedRadio ? selectedRadio.value : (state.purchaseOption || 'subscription');
				const variant = state.selectedVariant || {};
				const showAddToCart = Boolean(isAvailable && hasVariant);

				if (sharedAddToCartBtn) {
					sharedAddToCartBtn.setAttribute('data-plan-type', activePlanType);
					sharedAddToCartBtn.disabled = !showAddToCart;
					sharedAddToCartBtn.style.display = showAddToCart ? '' : 'none';

					const priceEl = sharedAddToCartBtn.querySelector('.lpv2-btn__price');
					const compareEl = sharedAddToCartBtn.querySelector('.lpv2-btn__compare_at_price');

					let priceValue;
					let compareValue;

					if (activePlanType === 'subscription') {
						priceValue = state.discountedPrice;
						compareValue = state.compareAtPrice;
					} else {
						priceValue = typeof variant.price === 'number' ? variant.price : undefined;
						compareValue = variant.compareAtPrice ?? variant.compare_at_price;
					}

					if (priceEl && typeof priceValue === 'number') {
						priceEl.textContent = formatMoney(priceValue, state.currency, state.locale);
					}

					if (compareEl) {
						if (typeof compareValue === 'number' && typeof priceValue === 'number' && compareValue > priceValue) {
							compareEl.textContent = formatMoney(compareValue, state.currency, state.locale);
							compareEl.style.display = '';
						} else {
							compareEl.style.display = 'none';
						}
					}
				}

				if (sharedNotifyBtn) {
					sharedNotifyBtn.setAttribute('data-plan-type', activePlanType);
					sharedNotifyBtn.style.display = showAddToCart ? 'none' : 'flex';
				}

				return;
			}

			// Fallback to legacy per-card buttons if shared buttons are not present
			const allPlanCards = container.querySelectorAll('.lpv2-plan-card');
			
			allPlanCards.forEach(card => {
				const addToCartBtn = card.querySelector('.lpv2-plan-card-btn');
				const notifyMeBtn = card.querySelector('.lpv2-plan-card-notify-btn');
				
				if (isAvailable && hasVariant) {
					if (addToCartBtn) {
						addToCartBtn.style.display = '';
						addToCartBtn.disabled = false;
					}
					if (notifyMeBtn) {
						notifyMeBtn.style.display = 'none';
					}
				} else {
					if (addToCartBtn) {
						addToCartBtn.style.display = 'none';
					}
					if (notifyMeBtn) {
						notifyMeBtn.style.display = '';
					}
				}
			});
		}

		function updateFreebieSelectionUI(state) {
			const selectedFreebies = state.selectedFreebies || [];

			// Check if freebies are enabled in theme customizer
			const enableFreebiesSwiper = window.LPV2MainProductInitialState?.enableFreebiesSwiper;
			const freebiesEnabled = enableFreebiesSwiper !== false && enableFreebiesSwiper !== "false";

			/* console.log('[DEBUG] updateFreebieSelectionUI:', {
				selectedFreebies: selectedFreebies,
				enableFreebiesSwiper: enableFreebiesSwiper,
				freebiesEnabled: freebiesEnabled,
				purchaseOption: state.purchaseOption
			}); */

			// Clear selectedFreebies if freebies are disabled
			if (!freebiesEnabled && selectedFreebies.length > 0) {
				// console.log('Clearing selected freebies because freebies are disabled in theme customizer');
				stateManager.setState({ selectedFreebies: [] });
				return; // Exit early to avoid processing with old selectedFreebies
			}

			// Only show freebie selections if on subscription tab and freebies are enabled
			const shouldShowFreebies = state.purchaseOption === 'subscription' && freebiesEnabled;

			container.querySelectorAll('.lpv2-freebie-item').forEach((item, index) => {
				const id = item.getAttribute('data-id');
				const isSelected = selectedFreebies.includes(id) || selectedFreebies.includes(Number(id));

				// For freebies enabled, first item should be selected by default
				let shouldShowSelected = shouldShowFreebies && isSelected;

				// Special case: if freebies are enabled and this is the first item and no freebies are selected yet,
				// default to selecting the first one
				if (freebiesEnabled && state.purchaseOption === 'subscription' && index === 0 && selectedFreebies.length === 0) {
					shouldShowSelected = true;
					// console.log('[DEBUG] Auto-selecting first freebie:', id);
					// Update the state to reflect this selection
					selectedFreebies.push(id);
					stateManager.setState({ selectedFreebies: selectedFreebies });
				}

				// Disable pointer events and add disabled class if freebies are disabled
				if (!freebiesEnabled || state.purchaseOption !== 'subscription') {
					item.classList.add('disabled');
					item.style.pointerEvents = 'none';
					item.style.opacity = '0.5';
				} else {
					item.classList.remove('disabled');
					item.style.pointerEvents = '';
					item.style.opacity = '';
				}

				item.classList.toggle('selected', shouldShowSelected);
				item.setAttribute('aria-checked', shouldShowSelected ? 'true' : 'false');
				const radio = item.querySelector('.lpv2-freebie-radio');
				if (radio) {
					radio.innerHTML = shouldShowSelected ? svgSelected : svgAdd;
				}
			});

			// Update freebies heading dynamically with selected gift price
			const headingEl = container.querySelector('.lpv2-freebies-heading');
			if (headingEl) {
				const selectedItems = Array.from(container.querySelectorAll('.lpv2-freebie-item.selected'));
				if (selectedItems.length > 0) {
					const priceFormatted = selectedItems[0].getAttribute('data-gift-price-formatted');
					if (priceFormatted) {
						const priceEl = headingEl.querySelector('.lpv2-freebie-worth-price');
						if (priceEl) {
							priceEl.textContent = priceFormatted;
						}
					}
				}
			}
		}

	function updateSkioPicker() {
		const state = stateManager.getState();

		// Check if we're in tabs mode
		const isTabsMode = state.layoutType === 'tabs';
		
		// Check if product is available and has a selected variant
		const isAvailable = state.selectedVariant && state.selectedVariant.available;
		const hasVariant = state.selectedVariant && state.selectedVariantId;

				// Get card references (needed for both tabs and cards mode)
	const subscriptionCard = container.querySelector('.lpv2-plan-card.lpv2-plan-card--subscription') || container.querySelector('.lpv2-plan-card--subscription');
	const onetimeCard = container.querySelector('.lpv2-plan-card.lpv2-plan-card--onetime') || container.querySelector('.lpv2-plan-card--onetime');
	
	// Get additional info elements (needed for both modes)
	const subscriptionAdditionalInfo = container.querySelector('.lpv2-plan-card.lpv2-plan-card--subscription .lpv2-plan-additional-info');
	const subscriptionBenefitsContainer = container.querySelector('.lpv2-plan-card.lpv2-plan-card--subscription .lpv2-plan-benefits');
	const oneTimeBenefitsContainer = container.querySelector('.lpv2-plan-card.lpv2-plan-card--onetime .lpv2-plan-benefits');

	// Check if subscription plans are available for the current variant
	// A variant has selling plans if it has selling_plan_allocations
	const hasSellingPlans = state.selectedVariant && 
		state.selectedVariant.selling_plan_allocations && 
		state.selectedVariant.selling_plan_allocations.length > 0;
	
	// Detect if the variant has changed
	const variantChanged = previousVariantId !== null && previousVariantId !== state.selectedVariantId;
	previousVariantId = state.selectedVariantId;
	
	// Handle subscription card visibility and purchase option based on plan availability
	if (subscriptionCard) {
		if (!hasSellingPlans) {
			subscriptionCard.style.display = 'none';
			// Automatically switch to one-time if subscription was selected
			if (state.purchaseOption === 'subscription') {
				stateManager.setState({
					purchaseOption: 'onetime'
				});
				return; // Exit early, the state change will trigger another update
			}
		} else {
			subscriptionCard.style.display = '';
		}
	}

	if (isTabsMode) {
			// In tabs mode, only update tab states, not card states
			const tabButtons = container.querySelectorAll('.lpv2-tab-button');
			const tabPanels = container.querySelectorAll('.lpv2-tab-panel');
			
			// Update tab button states
			tabButtons.forEach(btn => {
				const tabId = btn.getAttribute('data-tab-id');
				const isActive = tabId === state.purchaseOption;
				btn.classList.toggle('lpv2-tab-button--active', isActive);
				btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
				btn.addEventListener('click', () => {
					btn.parentElement.setAttribute('data-tab-id-active', tabId);
				});
				
				// Hide subscription tab if no plans available
				if (tabId === 'subscription' && !hasSellingPlans) {
					btn.style.display = 'none';
				} else if (tabId === 'subscription') {
					btn.style.display = '';
				}
			});
			
			// Update tab panel states
			tabPanels.forEach(panel => {
				const tabId = panel.getAttribute('data-tab-id');
				const isActive = tabId === state.purchaseOption;
				panel.classList.toggle('lpv2-tab-panel--active', isActive);
				
				// Hide subscription panel if no plans available
				if (tabId === 'subscription' && !hasSellingPlans) {
					panel.style.display = 'none';
				} else if (tabId === 'subscription') {
					panel.style.display = '';
				}
			});
				
				// Update tab content background based on active tab
				const tabContent = container.querySelector('.lpv2-tab-content');
				if (tabContent) {
					tabContent.classList.remove('lpv2-tab-content--subscription-active', 'lpv2-tab-content--onetime-active');
					if (state.purchaseOption === 'subscription') {
						tabContent.classList.add('lpv2-tab-content--subscription-active');
					} else if (state.purchaseOption === 'onetime') {
						tabContent.classList.add('lpv2-tab-content--onetime-active');
					}
				}
				
				// Update radio buttons to match state (for form submission)
				const subscriptionRadio = container.querySelector('input[value="subscription"]');
				const onetimeRadio = container.querySelector('input[value="onetime"]');
				if (subscriptionRadio && onetimeRadio) {
					subscriptionRadio.checked = state.purchaseOption === 'subscription';
					onetimeRadio.checked = state.purchaseOption === 'onetime';
				}
				
				// Update radio button visibility and card states in tabs mode
				
				// In tabs mode, update card states and always show radio buttons
				if (subscriptionCard) {
					const isSubscriptionActive = state.purchaseOption === 'subscription';
					subscriptionCard.classList.toggle('selected', isSubscriptionActive);
					subscriptionCard.classList.toggle('not-selected', !isSubscriptionActive);
					
					const subscriptionRadioSvg = subscriptionCard.querySelector('.skio-radio');
					if (subscriptionRadioSvg) {
						// Always show the radio button in tabs mode
						subscriptionRadioSvg.style.opacity = '1';
						subscriptionRadioSvg.style.transform = 'scale(0.9)';
					}
				}
				
				if (onetimeCard) {
					const isOnetimeActive = state.purchaseOption === 'onetime';
					onetimeCard.classList.toggle('selected', isOnetimeActive);
					onetimeCard.classList.toggle('not-selected', !isOnetimeActive);
					
					const onetimeRadioSvg = onetimeCard.querySelector('.skio-radio');
					if (onetimeRadioSvg) {
						// Always show the radio button in tabs mode
						onetimeRadioSvg.style.opacity = '1';
						onetimeRadioSvg.style.transform = 'scale(0.9)';
					}
				}
			} else {
				// In cards mode, update card states as before
				const subscriptionRadio = container.querySelector('input[value="subscription"]');
				const onetimeRadio = container.querySelector('input[value="onetime"]');

				if (subscriptionRadio && onetimeRadio) {
					const isSubscriptionSelected = state.purchaseOption === 'subscription';
					const isOnetimeSelected = state.purchaseOption === 'onetime';

					subscriptionRadio.checked = isSubscriptionSelected;
					onetimeRadio.checked = isOnetimeSelected;

					if (subscriptionCard) {
						subscriptionCard.classList.toggle('selected', isSubscriptionSelected);
						subscriptionCard.classList.toggle('not-selected', !isSubscriptionSelected);
						const subscriptionRadioSvg = subscriptionCard.querySelector('.skio-radio');
						if (subscriptionRadioSvg) {
							subscriptionRadioSvg.style.opacity = isSubscriptionSelected ? '1' : '0';
						}
					}

					if (isSubscriptionSelected) {
						if (subscriptionAdditionalInfo) subscriptionAdditionalInfo.classList.remove('hidden');
						if (subscriptionBenefitsContainer) subscriptionBenefitsContainer.classList.remove('hidden');
						if (oneTimeBenefitsContainer) oneTimeBenefitsContainer.classList.add('hidden');
					} else {
						if (subscriptionAdditionalInfo) subscriptionAdditionalInfo.classList.add('hidden');
						if (subscriptionBenefitsContainer) subscriptionBenefitsContainer.classList.add('hidden');
						if (oneTimeBenefitsContainer) oneTimeBenefitsContainer.classList.remove('hidden');
					}

					if (onetimeCard) {
						onetimeCard.classList.toggle('selected', isOnetimeSelected);
						onetimeCard.classList.toggle('not-selected', !isOnetimeSelected);
						const onetimeRadioSvg = onetimeCard.querySelector('.skio-radio');
						if (onetimeRadioSvg) {
							onetimeRadioSvg.style.opacity = isOnetimeSelected ? '1' : '0';
						}
					}
				}
			}

			// Update frequency buttons
			const frequencyButtons = container.querySelectorAll('.lpv2-frequency-btn');
			
			// If no plan is selected, default to the first button
			let effectiveSelectedPlanId = state.selectedPlanId;
			if (!effectiveSelectedPlanId && frequencyButtons.length > 0) {
				effectiveSelectedPlanId = frequencyButtons[0].getAttribute('data-plan-id');
				
				// Also update the state to reflect this default selection
				if (stateManager.state.selectedPlanId !== effectiveSelectedPlanId) {
					stateManager.state.selectedPlanId = effectiveSelectedPlanId;
				}
			}
			
			frequencyButtons.forEach((btn, index) => {
				const planId = btn.getAttribute('data-plan-id');
				const shouldBeSelected = String(planId) === String(effectiveSelectedPlanId);
				
				// Debug: Log the comparison values
				/* console.log(`Button ${index} comparison:`, {
					planId: planId,
					planIdType: typeof planId,
					effectiveSelectedPlanId: effectiveSelectedPlanId,
					effectiveSelectedPlanIdType: typeof effectiveSelectedPlanId,
					shouldBeSelected: shouldBeSelected
				}); */
				
				// Special case: if this is the first button and no plan is explicitly selected, always keep it selected
				if (index === 0 && !state.selectedPlanId && !effectiveSelectedPlanId) {
					btn.classList.add('selected');
				} else {
					btn.classList.toggle('selected', shouldBeSelected);
				}
			});

			// Update freebie selection UI
			updateFreebieSelectionUI(state);
			
			// Update plan card buttons based on availability
			updatePlanCardButtons(state, isAvailable, hasVariant);

			// Only update the selected card
			if (state.purchaseOption === 'subscription' && subscriptionCard) {
				const priceRow = subscriptionCard.querySelector('.lpv2-plan-price-row');
				if (priceRow) {
					const priceEl = priceRow.querySelector('.lpv2-plan-price');
					const compareEl = priceRow.querySelector('.lpv2-plan-compare');
					const savingsContainer = priceRow.querySelector('.lpv2-plan-savings-container');
					const savingsEl = priceRow.querySelector('.lpv2-plan-savings');
					const savingsAmountEl = priceRow.querySelector('.lpv2-plan-savings-amount');

				if (priceEl) priceEl.textContent = formatMoney(state.discountedPrice, state.currency, state.locale);
				if (compareEl) {
					// Use state.compareAtPrice which includes freebies' original prices for subscriptions
					if (state.compareAtPrice > state.discountedPrice) {
						compareEl.textContent = formatMoney(state.compareAtPrice, state.currency, state.locale);
						compareEl.style.display = '';
					} else {
						compareEl.style.display = 'none';
					}
				}
				if (savingsContainer && savingsEl && savingsAmountEl) {
					// Use state.compareAtPrice which includes freebies for savings calculation
					const actualSavings = state.compareAtPrice - state.discountedPrice;
					if (actualSavings > 0) {
						savingsContainer.style.display = '';
						savingsEl.style.display = '';
						savingsAmountEl.textContent = formatMoney(actualSavings, state.currency, state.locale);
					} else {
						savingsContainer.style.display = 'none';
						savingsEl.style.display = 'none';
						savingsAmountEl.textContent = '';
					}
				}
				}

				// Update additional info section with new plan price and frequency
				if (subscriptionAdditionalInfo) {
					const additionalInfoText = subscriptionAdditionalInfo.innerHTML;
					let updatedText = additionalInfoText;
					
					// Update plan price
					if (additionalInfoText.includes('@@plan_price@@')) {
						const newPlanPrice = formatMoney(state.recurringPrice || state.discountedPrice, state.currency, state.locale);
						updatedText = updatedText.replace(/@@plan_price@@/g, newPlanPrice);
					}
					
					// Update plan frequency - look for the specific text pattern
					const selectedPlan = state.selectedPlan;
					if (selectedPlan && selectedPlan.name) {
						const planName = selectedPlan.name.toLowerCase();
						
						let frequencyText = 'every 3 months'; // default fallback
						
						// More robust frequency extraction
						if (planName.includes('every')) {
							// Convert "EVERY 4 MONTHS" to "every 4 months"
							frequencyText = planName.replace(/\s+/g, ' ').trim();
						} else if (planName.includes('4')) {
							frequencyText = 'every 4 months';
						} else if (planName.includes('3')) {
							frequencyText = 'every 3 months';
						} else if (planName.includes('6')) {
							frequencyText = 'every 6 months';
						} else if (planName.includes('12')) {
							frequencyText = 'every 12 months';
						}
						
						// Replace the frequency text in the "Refills every X months" pattern
						// Use a regex to match the pattern and replace just the frequency part
						const frequencyRegex = /(Refills\s+)(every\s+\d+\s+months?)(\s+for)/i;
						if (frequencyRegex.test(updatedText)) {
							updatedText = updatedText.replace(frequencyRegex, `$1${frequencyText}$3`);
						}
					}
					
					subscriptionAdditionalInfo.innerHTML = updatedText;
				}

				// Update other price elements that might exist
				const allPlanPrices = document.querySelectorAll('.lpv2-plan-price');
				const allPlanCompares = document.querySelectorAll('.lpv2-plan-compare');
				const allPlanSavings = document.querySelectorAll('.lpv2-plan-savings');
				const allBtnPrices = document.querySelectorAll('.lpv2-btn__price');
				const allBtnCompareAtPrices = document.querySelectorAll('.lpv2-btn__compare_at_price');

				// Update all plan price elements
				allPlanPrices.forEach(el => {
					if (el.closest('.lpv2-plan-card--subscription')) {
						el.textContent = formatMoney(state.discountedPrice, state.currency, state.locale);
					}
				});

			// Update all plan compare elements
			allPlanCompares.forEach(el => {
				if (el.closest('.lpv2-plan-card--subscription')) {
					// Use state.compareAtPrice which includes freebies' original prices for subscriptions
					if (state.compareAtPrice > state.discountedPrice) {
						el.textContent = formatMoney(state.compareAtPrice, state.currency, state.locale);
						el.style.display = '';
					} else {
						el.style.display = 'none';
					}
				}
			});

			// Update all plan savings elements
			allPlanSavings.forEach(el => {
				if (el.closest('.lpv2-plan-card--subscription')) {
					const savingsAmountEl = el.querySelector('.lpv2-plan-savings-amount');
					if (savingsAmountEl) {
						// Use state.compareAtPrice which includes freebies for savings calculation
						const actualSavings = state.compareAtPrice - state.discountedPrice;
						if (actualSavings > 0) {
							savingsAmountEl.textContent = formatMoney(actualSavings, state.currency, state.locale);
							el.style.display = '';
						} else {
							el.style.display = 'none';
						}
					}
				}
			});

				// Update button price elements
				allBtnPrices.forEach(el => {
					el.textContent = formatMoney(state.discountedPrice, state.currency, state.locale);
				});

				// Update button compare at price elements
				allBtnCompareAtPrices.forEach(el => {
					// Use state.compareAtPrice which includes freebies' original prices
					if (state.compareAtPrice > state.discountedPrice) {
						el.textContent = formatMoney(state.compareAtPrice, state.currency, state.locale);
						el.style.display = '';
					} else {
						el.style.display = 'none';
					}
				});
			}

			if (state.purchaseOption === 'onetime' && onetimeCard) {
				const priceRow = onetimeCard.querySelector('.lpv2-plan-price-row');
				if (priceRow) {
					const priceEl = priceRow.querySelector('.lpv2-plan-price');
					const compareEl = priceRow.querySelector('.lpv2-plan-compare');
					const savingsContainer = priceRow.querySelector('.lpv2-plan-savings-container');
					const savingsEl = priceRow.querySelector('.lpv2-plan-savings');
					const savingsAmountEl = priceRow.querySelector('.lpv2-plan-savings-amount');

					if (priceEl && state.selectedVariant && typeof state.selectedVariant.price === 'number') {
						priceEl.textContent = formatMoney(state.selectedVariant.price, state.currency, state.locale);
					}
					if (compareEl) {
						if (state.selectedVariant && state.selectedVariant.compareAtPrice > state.selectedVariant.price) {
							compareEl.textContent = formatMoney(state.selectedVariant.compareAtPrice, state.currency, state.locale);
							compareEl.style.display = '';
						} else {
							compareEl.style.display = 'none';
						}
					}
					if (savingsContainer && savingsEl && savingsAmountEl) {
						const savings = state.selectedVariant && state.selectedVariant.compareAtPrice > state.selectedVariant.price
							? state.selectedVariant.compareAtPrice - state.selectedVariant.price
							: 0;
						if (savings > 0) {
							savingsContainer.style.display = '';
							savingsEl.style.display = '';
							savingsAmountEl.textContent = formatMoney(savings, state.currency, state.locale);
						} else {
							savingsContainer.style.display = 'none';
							savingsEl.style.display = 'none';
							savingsAmountEl.textContent = '';
						}
					}
				}

				// Update other price elements for onetime option
				const allPlanPrices = document.querySelectorAll('.lpv2-plan-price');
				const allPlanCompares = document.querySelectorAll('.lpv2-plan-compare');
				const allPlanSavings = document.querySelectorAll('.lpv2-plan-savings');
				const allBtnPrices = document.querySelectorAll('.lpv2-btn__price');
				const allBtnCompareAtPrices = document.querySelectorAll('.lpv2-btn__compare_at_price');

				// Update all plan price elements for onetime
				allPlanPrices.forEach(el => {
					if (el.closest('.lpv2-plan-card--onetime')) {
						if (state.selectedVariant && typeof state.selectedVariant.price === 'number') {
							el.textContent = formatMoney(state.selectedVariant.price, state.currency, state.locale);
						}
					}
				});

				// Update all plan compare elements for onetime
				allPlanCompares.forEach(el => {
					if (el.closest('.lpv2-plan-card--onetime')) {
						if (state.selectedVariant && state.selectedVariant.compareAtPrice > state.selectedVariant.price) {
							el.textContent = formatMoney(state.selectedVariant.compareAtPrice, state.currency, state.locale);
							el.style.display = '';
						} else {
							el.style.display = 'none';
						}
					}
				});

				// Update all plan savings elements for onetime
				allPlanSavings.forEach(el => {
					if (el.closest('.lpv2-plan-card--onetime')) {
						const savingsAmountEl = el.querySelector('.lpv2-plan-savings-amount');
						if (savingsAmountEl) {
							const savings = state.selectedVariant && state.selectedVariant.compareAtPrice > state.selectedVariant.price
								? state.selectedVariant.compareAtPrice - state.selectedVariant.price
								: 0;
							if (savings > 0) {
								savingsAmountEl.textContent = formatMoney(savings, state.currency, state.locale);
								el.style.display = '';
							} else {
								el.style.display = 'none';
							}
						}
					}
				});

				// Update button price elements for onetime
				allBtnPrices.forEach(el => {
					if (state.selectedVariant && typeof state.selectedVariant.price === 'number') {
						el.textContent = formatMoney(state.selectedVariant.price, state.currency, state.locale);
					}
				});

				// Update button compare at price elements for onetime
				allBtnCompareAtPrices.forEach(el => {
					// Use state.compareAtPrice which includes freebies' original prices
					if (state.compareAtPrice > state.selectedVariant.price) {
						el.textContent = formatMoney(state.compareAtPrice, state.currency, state.locale);
						el.style.display = '';
					} else {
						el.style.display = 'none';
					}
				});
			}

			// Show/hide the footer note based on purchaseOption
			const footerNote = container.querySelector('.lpv2-footer-note');
			if (footerNote) {
				if (state.purchaseOption === 'onetime') {
					footerNote.style.display = '';
				} else {
					footerNote.style.display = 'none';
				}
			}

			// Show/hide the onetime .lpv2-plan-additional-info based on purchaseOption
			const onetimeAdditionalInfo = onetimeCard ? onetimeCard.querySelector('.lpv2-plan-additional-info') : null;
			if (onetimeAdditionalInfo) {
				if (state.purchaseOption === 'onetime') {
					onetimeAdditionalInfo.style.display = '';
				} else {
					onetimeAdditionalInfo.style.display = 'none';
				}
			}
		}

		// Initialize tab functionality if layout type is tabs
		const state = stateManager.getState();
		if (state.layoutType === 'tabs') {
			// console.log('Layout type is tabs, initializing tab functionality...');
			initTabFunctionality();
		} else {
			// console.log('Layout type is cards, skipping tab functionality...');
		}

		// Attach event listeners for radio buttons (only in cards mode)
		container.querySelectorAll('.lpv2-plan-radio').forEach((el) => {
			el.addEventListener('change', (e) => {
				// Only handle radio button changes in cards mode, not tabs mode
				const currentState = stateManager.getState();
				if (currentState.layoutType === 'tabs') {
					return; // Don't handle radio changes in tabs mode
				}
				
				const value = el.value;
				
				if (value === 'subscription') {
					stateManager.setState({						
						purchaseOption: 'subscription',						
					});
				} else if (value === 'onetime') {
					stateManager.setState({
						purchaseOption: 'onetime',						
					});
				}
			});
		});

		function initTabFunctionality() {
			// console.log('Initializing tab functionality...');
			
			const tabButtons = container.querySelectorAll('.lpv2-tab-button');
			
			tabButtons.forEach(button => {
				button.addEventListener('click', () => {
					const tabId = button.getAttribute('data-tab-id');
					// console.log('Tab clicked:', tabId);
					
					// Update state manager - this will trigger updateSkioPicker which handles the UI updates
					stateManager.setState({
						purchaseOption: tabId
					});
					
					// Also update the Skio component's state to ensure proper form submission
					const skioComponent = document.querySelector('skio-plan-picker-component');
					if (skioComponent && skioComponent.purchaseOption !== undefined) {
						skioComponent.purchaseOption = tabId;
						
						// Update the selling plan based on the tab selection
						if (tabId === 'subscription') {
							// Set to subscription mode - find the first subscription group
							const subscriptionGroups = skioComponent.availableSellingPlanGroups?.filter(group => 
								group.name.toLowerCase().includes('subscription')
							);
							if (subscriptionGroups && subscriptionGroups.length > 0) {
								skioComponent.selectSellingPlanGroup(subscriptionGroups[0]);
							}
						} else if (tabId === 'onetime') {
							// Set to onetime mode
							skioComponent.selectSellingPlanGroup(null);
						}
					}
				});
				
				// Add keyboard navigation
				button.addEventListener('keydown', (e) => {
					if (e.key === 'Enter' || e.key === ' ') {
						e.preventDefault();
						button.click();
					}
				});
			});
		}

		container.querySelectorAll('.lpv2-frequency-btn').forEach((btn, idx) => {
			btn.addEventListener('click', () => {
				const planId = btn.getAttribute('data-plan-id');
				if (!planId) return;

				// When a frequency is selected, automatically select subscription option
				const subscriptionCard = container.querySelector('.lpv2-plan-card--subscription');
				if (subscriptionCard) {
					const subscriptionRadio = subscriptionCard.querySelector('.lpv2-plan-radio[value="subscription"]');
					if (subscriptionRadio) {
						subscriptionRadio.checked = true;
						// Trigger the change event to ensure the UI updates
						subscriptionRadio.dispatchEvent(new Event('change', { bubbles: true }));
					}
				}

				// Find the actual plan object from the selling plan groups
				let actualPlan = null;
				if (stateManager.getState().sellingPlanGroups) {
					for (const group of stateManager.getState().sellingPlanGroups) {
						const found = (group.selling_plans || []).find(p => p.id == planId);
						if (found) {
							actualPlan = found;
							break;
						}
					}
				}

				// Get the plan data from the button's data attributes or find it in the DOM
				const planData = actualPlan || {
					id: planId,
					name: btn.textContent.trim(),
					// Add any other plan data that might be needed
				};

				stateManager.setState({
					selectedPlanId: planId,
					selectedFrequency: idx,
					purchaseOption: 'subscription', // Force subscription when frequency is selected
					selectedPlan: planData // Set the actual plan object
				});
			});
		});

		container.querySelectorAll('.lpv2-freebie-item').forEach(item => {
			item.addEventListener('click', (e) => {
				// Ignore click if clicking on the View details button
				if (e && e.target && e.target.closest('.lpv2-freebie-view-btn')) {
					return;
				}

				// Only allow freebie selection if subscription is selected and freebies are enabled
				const currentState = stateManager.getState();
				if (currentState.purchaseOption !== 'subscription') {
					// console.log('Freebie selection only allowed for subscription option');
					return;
				}

				// Check if freebies are enabled in theme customizer
				const enableFreebiesSwiper = window.LPV2MainProductInitialState?.enableFreebiesSwiper;
				const freebiesEnabled = enableFreebiesSwiper !== false && enableFreebiesSwiper !== "false";
				if (!freebiesEnabled) {
					// console.log('Freebie selection disabled in theme customizer');
					return;
				}
				
				const id = item.getAttribute('data-id');
				let selected = Array.isArray(currentState.selectedFreebies) ? [...currentState.selectedFreebies] : [];
				const idx = selected.indexOf(id);
				const maxFreebies = currentState.maxFreebies || 1;
				if (maxFreebies === 1) {
					// Only one allowed: cannot deselect all, always have one selected
					if (idx === -1) {
						// Not currently selected, so select this one
						selected = [id];
						stateManager.setState({ selectedFreebies: selected });
					}
					// If already selected, do nothing
				} else {
					// Multi-select: toggle selection
					if (idx > -1) {
						// Deselect
						selected.splice(idx, 1);
					} else {
						if (selected.length < maxFreebies) {
							selected.push(id);
						} else {
							return;
						}
					}
					stateManager.setState({ selectedFreebies: selected });
				}
			});
		});

		// Listen for state changes
		document.addEventListener('lpv2-state-changed', updateSkioPicker);

		// Get initial state and ensure proper initialization
		const initialState = stateManager.getState();
		
		// Ensure the first frequency button is selected if no plan is explicitly selected
		if (!initialState.selectedPlanId) {
			const firstButton = container.querySelector('.lpv2-frequency-btn');
			if (firstButton) {
				const firstPlanId = firstButton.getAttribute('data-plan-id');
				
				// Find the actual plan object
				let firstPlan = null;
				if (initialState.sellingPlanGroups && initialState.sellingPlanGroups.length > 0) {
					const firstGroup = initialState.sellingPlanGroups[0];
					if (firstGroup && firstGroup.selling_plans && firstGroup.selling_plans.length > 0) {
						firstPlan = firstGroup.selling_plans[0];
					}
				}
				
				// Use setState to properly update the state
				stateManager.setState({
					selectedPlanId: firstPlanId,
					selectedPlan: firstPlan || { id: firstPlanId, name: firstButton.textContent.trim() }
				});
			}
		}
		
		// Debug: Track what's removing the selected class from ALL frequency buttons
		const debugButtons = container.querySelectorAll('.lpv2-frequency-btn');
		debugButtons.forEach((button, index) => {
			// Store the original classList methods
			const originalToggle = button.classList.toggle;
			const originalRemove = button.classList.remove;
			const originalAdd = button.classList.add;
			
			// Override toggle to track calls
			button.classList.toggle = function(className, force) {
				if (className === 'selected') {
					// console.log(`Toggle selected called on button ${index} with force:`, force, 'from:', new Error().stack);
				}
				return originalToggle.call(this, className, force);
			};
			
			// Override remove to track calls
			button.classList.remove = function(...classNames) {
				if (classNames.includes('selected')) {
					// console.log(`Remove selected called on button ${index} from:`, new Error().stack);
				}
				return originalRemove.call(this, ...classNames);
			};
			
			// Override add to track calls
			button.classList.add = function(...classNames) {
				if (classNames.includes('selected')) {
					// console.log(`Add selected called on button ${index} from:`, new Error().stack);
				}
				return originalAdd.call(this, ...classNames);
			};
		});
		
		// On load, update with initial state AFTER ensuring proper initialization
		updateSkioPicker();

		if (initialState.selectedPlan && initialState.selectedPlan.name) {
			const subscriptionAdditionalInfo = container.querySelector('.lpv2-plan-card.lpv2-plan-card--subscription .lpv2-plan-additional-info');
			if (subscriptionAdditionalInfo) {
				const additionalInfoText = subscriptionAdditionalInfo.innerHTML;
				const planName = initialState.selectedPlan.name.toLowerCase();
				let frequencyText = 'every 3 months';
				
				if (planName.includes('every')) {
					frequencyText = planName.replace(/\s+/g, ' ').trim();
				} else if (planName.includes('4')) {
					frequencyText = 'every 4 months';
				} else if (planName.includes('3')) {
					frequencyText = 'every 3 months';
				} else if (planName.includes('6')) {
					frequencyText = 'every 6 months';
				} else if (planName.includes('12')) {
					frequencyText = 'every 12 months';
				}
				
				// Replace the frequency text in the "Refills every X months" pattern
				const frequencyRegex = /(Refills\s+)(every\s+\d+\s+months?)(\s+for)/i;
				if (frequencyRegex.test(additionalInfoText)) {
					const updatedText = additionalInfoText.replace(frequencyRegex, `$1${frequencyText}$3`);
					subscriptionAdditionalInfo.innerHTML = updatedText;
				}
			}
		}

		initFreebiesSwiper();
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runPickerInit);
	} else {
		runPickerInit();
	}
}

let modalSwiperInstance = null;

function initFreebiesSwiper() {
	if (window.swiper) {
		const swiperContainer = document.querySelector('.lpv2-freebies-swiper.swiper-container');
		if (swiperContainer && !swiperContainer.swiper) {
			// Wait for DOM to be fully rendered and images loaded
			setTimeout(() => {
				new window.swiper(swiperContainer, {
					slidesPerView: 'auto',
					spaceBetween: 5,
					watchOverflow: true,
					resistanceRatio: 0,
					centeredSlides: false,
					navigation: {
						nextEl: '.lpv2-freebies-swiper.swiper-container .swiper-button-next',
						prevEl: '.lpv2-freebies-swiper.swiper-container .swiper-button-prev',
					},
					pagination: {
						el: '.lpv2-freebies-swiper.swiper-container .swiper-pagination',
						clickable: true,
					},
					loop: false,
				});
			}, 100);
		}
	}
	initFreebieModal();
}

function updateModalPagination(swiper) {
	if (!swiper || !swiper.slides) return;
	const total = swiper.slides.length;
	const current = swiper.realIndex !== undefined ? swiper.realIndex : (swiper.activeIndex || 0);

	const allPaginationContainers = document.querySelectorAll('.lpv2-freebie-modal .lpv2-modal-pagination');
	allPaginationContainers.forEach(container => {
		let bulletsHtml = '';
		for (let i = 0; i < total; i++) {
			const activeClass = i === current ? ' swiper-pagination-bullet-active' : '';
			bulletsHtml += `<span class="swiper-pagination-bullet${activeClass}" data-slide-index="${i}" role="button" aria-label="Go to slide ${i + 1}"></span>`;
		}
		container.innerHTML = bulletsHtml;
	});
}

function initFreebieModal() {
	console.log('[LPv2 Freebie Modal] initFreebieModal called');

	const openModal = (targetIndex = 0) => {
		const modalEl = document.getElementById('lpv2-freebie-modal');
		console.log('[LPv2 Freebie Modal] openModal called with targetIndex:', targetIndex, 'Modal element:', modalEl);
		if (!modalEl) {
			console.error('[LPv2 Freebie Modal] ERROR: #lpv2-freebie-modal element not found in DOM!');
			return;
		}
		modalEl.classList.add('is-open');
		modalEl.setAttribute('aria-hidden', 'false');
		document.body.style.overflow = 'hidden';

		const mainContent = document.getElementById('MainContent');
		if (mainContent) {
			mainContent.classList.add('popup-active');
		}

		if (!modalSwiperInstance) {
			console.log('[LPv2 Freebie Modal] Initializing modal swiper for index:', targetIndex);
			initFreebieModalSwiper(targetIndex);
		} else {
			console.log('[LPv2 Freebie Modal] Updating existing modal swiper and sliding to:', targetIndex);
			modalSwiperInstance.update();
			modalSwiperInstance.slideTo(targetIndex, 0);
			updateModalPagination(modalSwiperInstance);
		}
	};

	const closeModal = () => {
		console.log('[LPv2 Freebie Modal] closeModal called');
		const modalEl = document.getElementById('lpv2-freebie-modal');
		if (!modalEl) return;
		modalEl.classList.remove('is-open');
		modalEl.setAttribute('aria-hidden', 'true');
		document.body.style.overflow = '';

		const mainContent = document.getElementById('MainContent');
		if (mainContent) {
			mainContent.classList.remove('popup-active');
		}
	};

	if (!window._freebieViewBtnDelegated) {
		window._freebieViewBtnDelegated = true;
		console.log('[LPv2 Freebie Modal] Binding global document click delegation for View button & nav');
		document.addEventListener('click', (e) => {
			const viewBtn = e.target.closest('.lpv2-freebie-view-btn');
			if (viewBtn) {
				console.log('[LPv2 Freebie Modal] View button click detected via delegation! dataset:', viewBtn.dataset);
				e.preventDefault();
				e.stopPropagation();
				const index = parseInt(viewBtn.dataset.freebieIndex || '0', 10);
				openModal(index);
			} else if (e.target.closest('.lpv2-freebie-modal-overlay') || e.target.closest('.lpv2-freebie-modal-close')) {
				console.log('[LPv2 Freebie Modal] Modal overlay or close button clicked');
				e.preventDefault();
				closeModal();
			} else if (e.target.closest('.lpv2-modal-nav-prev')) {
				e.preventDefault();
				if (modalSwiperInstance) {
					modalSwiperInstance.slidePrev();
				}
			} else if (e.target.closest('.lpv2-modal-nav-next')) {
				e.preventDefault();
				if (modalSwiperInstance) {
					modalSwiperInstance.slideNext();
				}
			} else if (e.target.closest('.swiper-pagination-bullet')) {
				const bullet = e.target.closest('.swiper-pagination-bullet');
				const index = parseInt(bullet.dataset.slideIndex, 10);
				if (!isNaN(index) && modalSwiperInstance) {
					e.preventDefault();
					modalSwiperInstance.slideTo(index);
				}
			}
		});

		document.addEventListener('keydown', (e) => {
			const modal = document.getElementById('lpv2-freebie-modal');
			if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
				closeModal();
			}
		});
	}
}

function initFreebieModalSwiper(initialSlide = 0) {
	if (window.swiper) {
		const modalSwiperContainer = document.querySelector('.lpv2-freebie-modal-swiper');
		if (modalSwiperContainer && !modalSwiperInstance) {
			modalSwiperInstance = new window.swiper(modalSwiperContainer, {
				slidesPerView: 'auto',
				spaceBetween: 14,
				initialSlide: initialSlide,
				centeredSlides: false,
				watchOverflow: true,
				breakpoints: {
					769: {
						slidesPerView: 1,
						spaceBetween: 0,
					}
				},
				on: {
					init: function () {
						updateModalPagination(this);
					},
					slideChange: function () {
						updateModalPagination(this);
					},
					update: function () {
						updateModalPagination(this);
					}
				}
			});
			updateModalPagination(modalSwiperInstance);
		}
	}
}